import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import Title from '../general/title'
import getData from 'helpers/submitData'
import { loadingStatus } from 'actions'
import helpers from "helpers/helpers"
import FullTable from "components/FullTable"
import Switch from "react-switch"

class ExceptionsLog extends Component {

	constructor(props) {
		super(props)
		this.state = {
			rows: [],
			filtered: [],
			sorted: [],
			showToday: false
		}
	}

	componentDidMount() {
		this.props.loadingStatus(false)
		getData("getExceptions", {dates: this.props.currentDates, properties: this.props.activeProperties}).then((resp) => {
			//console.log(resp.data)
			this.setState({rows:resp.data})
		}).catch(e => {
			console.log(e)
		})
	}

	componentDidUpdate(prevProps) {
		//if(prevProps.activeProperties !== this.props.activeProperties) {
		if(!_.isEqual(prevProps, this.props)) {
			getData("getExceptions", { dates: this.props.currentDates, properties: this.props.activeProperties })
				.then((resp) => {
					
					this.setState({ rows: resp.data })
					this.props.loadingStatus(false)
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	countActions = (id) => {
		var count = 0
		this.props.payload.activity.forEach((r) => {
			if(id == r.user) {
				count++
			}
		})

		return count
	}

	buildTable = () => {
		let ret = []
		let today = moment().format("YYYY-MM-DD")
		_.forEach(this.state.rows, v => {
			if(this.state.showToday) {
				let date = moment.unix(v.addedDate).format("YYYY-MM-DD")
				if(date !== today) {
					return
				}
			}
			let b = _.find(this.props.payload.public.builders, {id: v.builder})
			if(!b) { b = {name: ''} }
			let type = _.find(this.props.payload.public.exceptions, {id: v.type})
			let property = _.find(this.props.payload.public.properties, {id: v.property})
			ret.push({
				builder: b.name,
				addedDate: v.addedDate,
				type: type ? type.name : '',
				property: property ? property.name : '',
				message: v.message
			})
		})

		return ret
	}

	createTable = () => {
		const columns = [
			{
				Header: "Type",
				accessor: "type",
				filterMethod: (f, r) => helpers.tableText(f, r, "type"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Property",
				accessor: "property",
				filterMethod: (f, r) => helpers.tableText(f, r, "property"),
			},
			{
				Header: "Message",
				accessor: "message",
				filterMethod: (f, r) => helpers.tableText(f, r, "message"),
			},
			{
				Header: "Date",
				accessor: "addedDate",
				Cell: (v) => {
					return moment.unix(v.value).format("MM/DD/YY LT")
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
		]
		return (
			<div className="content">
				<FullTable
					data={this.buildTable()}
					columns={columns}
					name="activityExceptions"
					title="Builder Feed Exceptions"
					defaultSorted={[
						{
							id: "addedDate",
							desc: true,
						},
					]}
				/>
			</div>
		)
	}

	render() {

		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Feed Exceptions Log" />
					<div className="content flex items-center">
						<Switch
							onChange={() => {
								this.setState({ showToday: !this.state.showToday })
							}}
							checked={this.state.showToday}
							checkedIcon={false}
							uncheckedIcon={false}
							key={"switch"}
							id={"switch"}
						/>
						<p className="text-blue text-sm font-bold ml-2">
							Showing {this.state.showToday ? "Today" : "All"}
						</p>
					</div>
					{this.createTable()}
				</div>
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
        compareDates: state.compareDates,
		payload: state.payload,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		loadingStatus
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ExceptionsLog)